import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Typography, Tooltip, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { Chart, registerables } from 'chart.js';
import Histogram from './Histogram';
import { useGetProductQuery } from '../features/api/openFoodFacts/apiFoodFactsSlice';
import { useFetchAdvancedReviewQuery } from '../features/api/rest/apiChartReviewSlice';

Chart.register(...registerables);
function ChartReview() {
  const { ean } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [checkOption, setcheckOption] = useState(false);
  const [filter, setfilter] = useState(searchParams.get('type') || ' ');
  const { data: review = [] } = useFetchAdvancedReviewQuery({
    ean,
  });

  const { currentData } = useGetProductQuery(ean);
  const product = currentData?.product;
  const [dataChart, setDataChart] = useState(['', '']);
  const [AverageChart, setAverageChart] = useState(['', '']);
  const [labels, setlabels] = useState(['1', '2', '3', '4', '5']);
  const [dataStack, setDataStack] = useState([{ label: t('charts.histogram.review'), data: ['', ''], backgroundColor: 'rgb(255, 99, 132)' }]);
  const [check, setcheck] = useState(false);
  const [checkdata, setcheckdata] = useState(false);
  const [starArray, setStarArray] = useState([]);
  const [OtherArray, setOtherArray] = useState([]);
  const [FemaleArray, setFemaleArray] = useState([]);
  const [MaleArray, setMaleArray] = useState([]);
  const [GenderArray, setGenderArray] = useState([]);
  const [GenderAverage, setGenderAverage] = useState([]);

  const [OneArray, setOneArray] = useState([]);
  const [TwoArray, setTwoArray] = useState([]);
  const [TreArray, setTreArray] = useState([]);
  const [FourArray, setFourArray] = useState([]);
  const [FiveArray, setFiveArray] = useState([]);
  const [educationArray, seteducationArray] = useState([]);
  const [educationAverage, seteducationAverage] = useState([]);

  const [Age1Array, setAge1Array] = useState([]);
  const [Age2Array, setAge2Array] = useState([]);
  const [Age3Array, setAge3Array] = useState([]);
  const [Age4Array, setAge4Array] = useState([]);
  const [Age5Array, setAge5Array] = useState([]);
  const [Age6Array, setAge6Array] = useState([]);
  const [Age7Array, setAge7Array] = useState([]);
  const [AgeArray, setAgeArray] = useState([]);
  const [AgeAverage, setAgeAverage] = useState([]);

  const [StatusArrayS, setStatusArrayS] = useState([]);
  const [StatusArrayM, setStatusArrayM] = useState([]);
  const [StatusArrayD, setStatusArrayD] = useState([]);
  const [StatusArrayW, setStatusArrayW] = useState([]);
  const [StatusArray, setStatusArray] = useState([]);
  const [StatusAverage, setStatusAverage] = useState([]);

  const { data: O = [] } = useFetchAdvancedReviewQuery({ ean, gen: 'O' });
  const { data: F = [] } = useFetchAdvancedReviewQuery({ ean, gen: 'F' });
  const { data: M = [] } = useFetchAdvancedReviewQuery({ ean, gen: 'M' });

  const { data: One = [] } = useFetchAdvancedReviewQuery({ ean, education: '0' });
  const { data: Two = [] } = useFetchAdvancedReviewQuery({ ean, education: '1' });
  const { data: Tre = [] } = useFetchAdvancedReviewQuery({ ean, education: '2' });
  const { data: Four = [] } = useFetchAdvancedReviewQuery({ ean, education: '3' });
  const { data: Five = [] } = useFetchAdvancedReviewQuery({ ean, education: '4' });

  const { data: Age1 = [] } = useFetchAdvancedReviewQuery({ ean, lt: 18 });
  const { data: Age2 = [] } = useFetchAdvancedReviewQuery({ ean, lt: 25, gt: 18 });
  const { data: Age3 = [] } = useFetchAdvancedReviewQuery({ ean, lt: 35, gt: 25 });
  const { data: Age4 = [] } = useFetchAdvancedReviewQuery({ ean, lt: 45, gt: 35 });
  const { data: Age5 = [] } = useFetchAdvancedReviewQuery({ ean, lt: 55, gt: 45 });
  const { data: Age6 = [] } = useFetchAdvancedReviewQuery({ ean, lt: 65, gt: 55 });
  const { data: Age7 = [] } = useFetchAdvancedReviewQuery({ ean, gt: 65 });

  const { data: SS = [] } = useFetchAdvancedReviewQuery({ ean, marital: 'S' });
  const { data: SM = [] } = useFetchAdvancedReviewQuery({ ean, marital: 'M' });
  const { data: SD = [] } = useFetchAdvancedReviewQuery({ ean, marital: 'D' });
  const { data: SW = [], isLoading } = useFetchAdvancedReviewQuery({ ean, marital: 'W' });
  if (!isLoading && !check) {
    setcheck(true);
    setcheckdata(true);
  }
  useEffect(() => {
    if (checkdata) {
      setStarArray([review?.star1 || null, review?.star2 || null, review?.star3 || null, review?.star4 || null, review?.star5 || null]);
      setOtherArray([O?.star1 || null, O?.star2 || null, O?.star3 || null, O?.star4 || null, O?.star5 || null]);
      setFemaleArray([F?.star1 || null, F?.star2 || null, F?.star3 || null, F?.star4 || null, F?.star5 || null]);
      setMaleArray([M?.star1 || null, M?.star2 || null, M?.star3 || null, M?.star4 || null, M?.star5 || null]);
      setGenderArray([M?.total_reviews || null, F?.total_reviews || null, O?.total_reviews || null]);
      setGenderAverage([M?.average || null, F?.average || null, O?.average || null]);

      setOneArray([One?.star1 || null, One?.star2 || null, One?.star3 || null, One?.star4 || null, One?.star5 || null]);
      setTwoArray([Two?.star1 || null, Two?.star2 || null, Two?.star3 || null, Two?.star4 || null, Two?.star5 || null]);
      setTreArray([Tre?.star1 || null, Tre?.star2 || null, Tre?.star3 || null, Tre?.star4 || null, Tre?.star5 || null]);
      setFourArray([Four?.star1 || null, Four?.star2 || null, Four?.star3 || null, Four?.star4 || null, Four?.star5 || null]);
      setFiveArray([Five?.star1 || null, Five?.star2 || null, Five?.star3 || null, Five?.star4 || null, Five?.star5 || null]);
      seteducationArray([One?.total_reviews || null, Two?.total_reviews || null, Tre?.total_reviews || null, Four?.total_reviews || null, Five?.total_reviews || null]);
      seteducationAverage([One?.average || null, Two?.average || null, Tre?.average || null, Four?.average || null, Five?.average || null]);

      setAge1Array([Age1?.star1 || null, Age1?.star2 || null, Age1?.star3 || null, Age1?.star4 || null, Age1?.star5 || null]);
      setAge2Array([Age2?.star1 || null, Age2?.star2 || null, Age2?.star3 || null, Age2?.star4 || null, Age2?.star5 || null]);
      setAge3Array([Age3?.star1 || null, Age3?.star2 || null, Age3?.star3 || null, Age3?.star4 || null, Age3?.star5 || null]);
      setAge4Array([Age4?.star1 || null, Age4?.star2 || null, Age4?.star3 || null, Age4?.star4 || null, Age4?.star5 || null]);
      setAge5Array([Age5?.star1 || null, Age5?.star2 || null, Age5?.star3 || null, Age5?.star4 || null, Age5?.star5 || null]);
      setAge6Array([Age6?.star1 || null, Age6?.star2 || null, Age6?.star3 || null, Age6?.star4 || null, Age6?.star5 || null]);
      setAge7Array([Age7?.star1 || null, Age7?.star2 || null, Age7?.star3 || null, Age7?.star4 || null, Age7?.star5 || null]);
      setAgeArray([Age1?.total_reviews || null, Age2?.total_reviews || null, Age3?.total_reviews || null, Age4?.total_reviews || null, Age5?.total_reviews || null, Age6?.total_reviews || null, Age7?.total_reviews || null]);
      setAgeAverage([Age1?.average || null, Age2?.average || null, Age3?.average || null, Age4?.average || null, Age5?.average || null, Age6?.average || null, Age7?.average || null]);

      setStatusArrayS([SS?.star1 || null, SS?.star2 || null, SS?.star3 || null, SS?.star4 || null, SS?.star5 || null]);
      setStatusArrayM([SM?.star1 || null, SM?.star2 || null, SM?.star3 || null, SM?.star4 || null, SM?.star5 || null]);
      setStatusArrayD([SD?.star1 || null, SD?.star2 || null, SD?.star3 || null, SD?.star4 || null, SD?.star5 || null]);
      setStatusArrayW([SW?.star1 || null, SW?.star2 || null, SW?.star3 || null, SW?.star4 || null, SW?.star5 || null]);
      setStatusArray([SS?.total_reviews || null, SM?.total_reviews || null, SD?.total_reviews || null, SW?.total_reviews || null]);
      setStatusAverage([SS?.average || null, SM?.average || null, SD?.average || null, SW?.average || null]);
      setcheckdata(false);
    }
  }, [
    Age1?.average,
    Age1?.star1,
    Age1?.star2,
    Age1?.star3,
    Age1?.star4,
    Age1?.star5,
    Age1?.total_reviews,
    Age2?.average,
    Age2?.star1,
    Age2?.star2,
    Age2?.star3,
    Age2?.star4,
    Age2?.star5,
    Age2?.total_reviews,
    Age3?.average,
    Age3?.star1,
    Age3?.star2,
    Age3?.star3,
    Age3?.star4,
    Age3?.star5,
    Age3?.total_reviews,
    Age4?.average,
    Age4?.star1,
    Age4?.star2,
    Age4?.star3,
    Age4?.star4,
    Age4?.star5,
    Age4?.total_reviews,
    Age5?.average,
    Age5?.star1,
    Age5?.star2,
    Age5?.star3,
    Age5?.star4,
    Age5?.star5,
    Age5?.total_reviews,
    Age6?.average,
    Age6?.star1,
    Age6?.star2,
    Age6?.star3,
    Age6?.star4,
    Age6?.star5,
    Age6?.total_reviews,
    Age7?.average,
    Age7?.star1,
    Age7?.star2,
    Age7?.star3,
    Age7?.star4,
    Age7?.star5,
    Age7?.total_reviews,
    F?.average,
    F?.star1,
    F?.star2,
    F?.star3,
    F?.star4,
    F?.star5,
    F?.total_reviews,
    Five?.average,
    Five?.star1,
    Five?.star2,
    Five?.star3,
    Five?.star4,
    Five?.star5,
    Five?.total_reviews,
    Four?.average,
    Four?.star1,
    Four?.star2,
    Four?.star3,
    Four?.star4,
    Four?.star5,
    Four?.total_reviews,
    M?.average,
    M?.star1,
    M?.star2,
    M?.star3,
    M?.star4,
    M?.star5,
    M?.total_reviews,
    O?.average,
    O?.star1,
    O?.star2,
    O?.star3,
    O?.star4,
    O?.star5,
    O?.total_reviews,
    One?.average,
    One?.star1,
    One?.star2,
    One?.star3,
    One?.star4,
    One?.star5,
    One?.total_reviews,
    SD?.average,
    SD?.star1,
    SD?.star2,
    SD?.star3,
    SD?.star4,
    SD?.star5,
    SD?.total_reviews,
    SM?.average,
    SM?.star1,
    SM?.star2,
    SM?.star3,
    SM?.star4,
    SM?.star5,
    SM?.total_reviews,
    SS?.average,
    SS?.star1,
    SS?.star2,
    SS?.star3,
    SS?.star4,
    SS?.star5,
    SS?.total_reviews,
    SW?.average,
    SW?.star1,
    SW?.star2,
    SW?.star3,
    SW?.star4,
    SW?.star5,
    SW?.total_reviews,
    Tre?.average,
    Tre?.star1,
    Tre?.star2,
    Tre?.star3,
    Tre?.star4,
    Tre?.star5,
    Tre?.total_reviews,
    Two?.average,
    Two?.star1,
    Two?.star2,
    Two?.star3,
    Two?.star4,
    Two?.star5,
    Two?.total_reviews,
    checkdata,
    review?.star1,
    review?.star2,
    review?.star3,
    review?.star4,
    review?.star5,
  ]);
  useEffect(() => {
    if (filter === 'general') navigate(`${searchParams.has('type') ? `?type=${filter}` : `?type=${filter}`}`);
    if (filter === 'education') navigate(`${searchParams.has('type') ? `?type=${filter}` : ''}`);
    if (filter === 'status') navigate(`${searchParams.has('type') ? `?type=${filter}` : ''}`);
    if (filter === 'age') navigate(`${searchParams.has('type') ? `?type=${filter}` : ''}`);
    if (filter === 'gender') navigate(`${searchParams.has('type') ? `?type=${filter}` : ''}`);
  }, [filter, navigate, searchParams]);
  const general = () => {
    setDataStack([
      {
        label: t('charts.histogram.review'),
        data: starArray,
        backgroundColor: 'rgb(255, 99, 132)',
      },
    ]);
    setlabels([t('charts.histogram.1star'), t('charts.histogram.2star'), t('charts.histogram.3star'), t('charts.histogram.4star'), t('charts.histogram.5star')]);
    setDataChart(starArray);
    setAverageChart(starArray);
    setfilter('general');

    setcheckOption(false);
    setDataStart();
  };
  const gender = () => {
    setDataStack([
      {
        label: t('charts.histogram.other'),
        data: OtherArray,
        backgroundColor: 'rgb(75, 192, 192)',
      },
      {
        label: t('charts.histogram.female'),
        data: FemaleArray,
        backgroundColor: 'rgb(255, 99, 132)',
      },
      {
        label: t('charts.histogram.male'),
        data: MaleArray,
        backgroundColor: 'rgb(53, 162, 235)',
      },
    ]);

    setDataChart(GenderArray);
    setAverageChart(GenderAverage);
    setfilter('gender');
    setlabels([t('charts.histogram.male'), t('charts.histogram.female'), t('charts.histogram.other')]);
    setcheckOption(false);
    setDataStart();
  };

  const age = () => {
    setDataStack([
      {
        label: '<18',
        data: Age1Array,
        backgroundColor: 'rgb(0,128,128)',
      },
      {
        label: '18<X<24',
        data: Age2Array,
        backgroundColor: 'rgb(0,0,128)',
      },
      {
        label: '25<X<34',
        data: Age3Array,
        backgroundColor: 'rgb(0,0,255)',
      },
      {
        label: '35<X<44',
        data: Age4Array,
        backgroundColor: 'rgb(0,255,255)',
      },
      {
        label: '45<X<54',
        data: Age5Array,
        backgroundColor: 'rgb(0,255,0)',
      },
      {
        label: '55<X<64',
        data: Age6Array,
        backgroundColor: 'rgb(128,0,128)',
      },
      {
        label: '>64',
        data: Age7Array,
        backgroundColor: 'rgb(128,128,128)',
      },
    ]);
    setDataChart(AgeArray);
    setAverageChart(AgeAverage);
    setfilter('age');
    setlabels(['<18', '18-24', '25-34', '35-44', '45-54', '55-64', '64<']);
    setcheckOption(false);
    setDataStart();
  };

  const education = () => {
    setDataStack([
      {
        label: t('charts.histogram.educational_level.primary'),
        data: OneArray,
        backgroundColor: 'rgb(255, 99, 132)',
      },
      {
        label: t('charts.histogram.educational_level.secondary'),
        data: TwoArray,
        backgroundColor: 'rgb(245, 192, 192)',
      },
      {
        label: t('charts.histogram.educational_level.bachelor'),
        data: TreArray,
        backgroundColor: 'rgb(53, 162, 235)',
      },
      {
        label: t('charts.histogram.educational_level.master'),
        data: FourArray,
        backgroundColor: 'rgb(53, 262, 235)',
      },
      {
        label: t('charts.histogram.educational_level.phd'),
        data: FiveArray,
        backgroundColor: 'rgb(53, 162, 35)',
      },
    ]);
    setDataChart(educationArray);
    setAverageChart(educationAverage);
    setfilter('education');
    setlabels([t('charts.histogram.educational_level.primary'), t('charts.histogram.educational_level.secondary'), t('charts.histogram.educational_level.bachelor'), t('charts.histogram.educational_level.master'), t('charts.histogram.educational_level.phd')]);
    setcheckOption(false);
    setDataStart();
  };

  const status = () => {
    setDataStack([
      {
        label: t('charts.histogram.marital_status.single'),
        data: StatusArrayS,
        backgroundColor: 'rgb(0,128,128)',
      },
      {
        label: t('charts.histogram.marital_status.married'),
        data: StatusArrayM,
        backgroundColor: 'rgb(0,0,128)',
      },
      {
        label: t('charts.histogram.marital_status.divorced'),
        data: StatusArrayD,
        backgroundColor: 'rgb(0,0,255)',
      },
      {
        label: t('charts.histogram.marital_status.widowed'),
        data: StatusArrayW,
        backgroundColor: 'rgb(0,255,255)',
      },
    ]);

    setDataChart(StatusArray);
    setAverageChart(StatusAverage);

    setlabels([t('charts.histogram.marital_status.single'), t('charts.histogram.marital_status.married'), t('charts.histogram.marital_status.divorced'), t('charts.histogram.marital_status.widowed')]);
    setfilter('status');
    setcheckOption(false);
    setDataStart();
  };

  const [histogramOptions, setH] = useState({});
  const [HistogramData, setHD] = useState({});
  const [AverageOptions, setA] = useState({});
  const [AverageData, setAD] = useState({});
  const [optionStar, setS] = useState({});
  const [dataStar, setSD] = useState({});
  let textfilter;
  const setDataStart = () => {
    if (filter === 'general') textfilter = t('charts.histogram.stars');
    if (filter === 'gender') textfilter = t('charts.histogram.gender');
    if (filter === 'age') textfilter = t('charts.histogram.age');
    if (filter === 'status') textfilter = t('charts.histogram.status');
    if (filter === 'education') textfilter = t('charts.histogram.educationalLevel');

    setH({
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: `${t('charts.histogram.total_reviews', { category: textfilter })}`,
        },
      },
    });
    setHD({
      labels,
      datasets: [
        {
          label: t('charts.histogram.number_of_review'),
          data: dataChart,
          backgroundColor: 'rgb(0,128,128)',
        },
      ],
    });
    setA({
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: ` ${t('charts.histogram.average_score', { category: textfilter })} `,
        },
      },
    });
    setAD({
      labels,
      datasets: [
        {
          label: t('charts.histogram.average_rating'),
          data: AverageChart,
          backgroundColor: 'rgb(0,128,128)',
        },
      ],
    });
    setS({
      plugins: {
        title: {
          display: true,
          text: `${t('charts.histogram.review_by_score', { category: textfilter })}`,
        },
      },
      responsive: true,
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
        },
      },
    });
    setSD({
      labels: [t('charts.histogram.1star'), t('charts.histogram.2star'), t('charts.histogram.3star'), t('charts.histogram.4star'), t('charts.histogram.5star')],
      datasets: dataStack,
    });
    if (Object.keys(dataChart).length > 2) setcheckOption(true);
  };

  if (Object.keys(review)?.length === 0) {
    return (
      <div style={{ textAlign: 'left' }}>
        <Typography sx={{ paddingBottom: '1em' }}>{t('charts.histogram.noreview')}</Typography>
        <Button sx={{ margin: '5px' }} variant="contained">
          {t('organizations.backOrganizations')}
        </Button>
      </div>
    );
  }
  const checkstar = starArray.some((star) => star != null);
  if (!checkOption && checkstar) {
    if (filter === ' ') {
      navigate(`?type=general`);
      general();
    }

    if (filter === 'general') general();
    if (filter === 'status') status();
    if (filter === 'gender') gender();
    if (filter === 'age') age();
    if (filter === 'education') education();

    setDataStart();
  }

  if (checkOption)
    return (
      <Grid style={{ display: 'flex', justifyContent: 'center', flexDirection: 'colum' }}>
        <div style={{ width: '800px', height: '1100px' }}>
          <Grid container spacing={0.5} sx={{ justifyContent: 'space-between' }}>
            <Typography sx={{ padding: '1em', align: 'left', fontSize: '1.2em' }}>{product?.product_name}</Typography>
            <Tooltip title={t('charts.histogram.info')}>
              <Typography sx={{ margin: '1em', align: 'right', fontSize: '1.2em' }}>
                {t('charts.histogram.number_of_review')}: {review.total_reviews}
              </Typography>
            </Tooltip>
          </Grid>
          <Grid container spacing={0.5} sx={{ justifyContent: 'center' }}>
            <FormControl>
              <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="filter group" value={searchParams.get('type') || 'general'}>
                <FormControlLabel
                  value="general"
                  control={<Radio sx={{ display: 'none', '&.Mui-checked': { '&, & + .MuiFormControlLabel-label': { border: '0px solid black', backgroundColor: '#1976d2', color: 'white' } } }} />}
                  label={t('charts.histogram.review')}
                  onClick={general}
                  sx={{ '.MuiFormControlLabel-label': { padding: '5px 20px 5px 20px', margin: '0px 4px 0px 4px', border: '2px solid gray', borderRadius: '30px', backgroundColor: 'white' } }}
                />
                <FormControlLabel
                  value="gender"
                  control={<Radio sx={{ display: 'none', '&.Mui-checked': { '&, & + .MuiFormControlLabel-label': { border: '0px solid black', backgroundColor: '#1976d2', color: 'white' } } }} />}
                  label={t('charts.histogram.gender')}
                  onClick={gender}
                  sx={{ '.MuiFormControlLabel-label': { padding: '5px 20px 5px 20px', margin: '0px 4px 0px 4px', border: '2px solid gray', borderRadius: '30px', backgroundColor: 'white' } }}
                />
                <FormControlLabel
                  value="age"
                  control={<Radio sx={{ display: 'none', '&.Mui-checked': { '&, & + .MuiFormControlLabel-label': { border: '0px solid black', backgroundColor: '#1976d2', color: 'white' } } }} />}
                  label={t('charts.histogram.age')}
                  onClick={age}
                  sx={{ '.MuiFormControlLabel-label': { padding: '5px 20px 5px 20px', margin: '0px 4px 0px 4px', border: '2px solid gray', borderRadius: '30px', backgroundColor: 'white' } }}
                />
                <FormControlLabel
                  value="education"
                  control={<Radio sx={{ display: 'none', '&.Mui-checked': { '&, & + .MuiFormControlLabel-label': { border: '0px solid black', backgroundColor: '#1976d2', color: 'white' } } }} />}
                  label={t('charts.histogram.educationalLevel')}
                  onClick={education}
                  sx={{ '.MuiFormControlLabel-label': { padding: '5px 20px 5px 20px', margin: '0px 4px 0px 4px', border: '2px solid gray', borderRadius: '30px', backgroundColor: 'white' } }}
                />
                <FormControlLabel
                  value="status"
                  control={<Radio sx={{ display: 'none', '&.Mui-checked': { '&, & + .MuiFormControlLabel-label': { border: '0px solid black', backgroundColor: '#1976d2', color: 'white' } } }} />}
                  label={t('charts.histogram.status')}
                  onClick={status}
                  sx={{ '.MuiFormControlLabel-label': { padding: '5px 20px 5px 20px', margin: '0px 4px 0px 4px', border: '2px solid gray', borderRadius: '30px', backgroundColor: 'white' } }}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          {filter !== 'general' && <Histogram options={optionStar} data={dataStar} />}
          {filter !== 'general' && <Histogram options={histogramOptions} data={HistogramData} sx={{ paddingBottom: '3em' }} />}
          {filter !== 'general' && <Histogram options={AverageOptions} data={AverageData} />}
          {filter === 'general' && <Histogram options={histogramOptions} data={HistogramData} sx={{ paddingBottom: '3em' }} />}
          <Typography sx={{ textColor: 'gray', fontSize: '11px', paddingTop: '2em', paddingBottom: '2em' }}>{t('charts.histogram.info')}</Typography>
        </div>
      </Grid>
    );
}

export default ChartReview;
